import { Directive, EventEmitter, OnDestroy, Output } from '@angular/core';
import { BaseDialog } from '@core/services/overlay/overlay.model';
import { Subject } from 'rxjs';
import { AbstractFormComponent } from '../../form/abstract-form.component';

@Directive()
export abstract class AbstractBaseDialogFormComponent<T = undefined>
  extends AbstractFormComponent<T>
  implements BaseDialog, OnDestroy
{
  @Output() closeRequested = new EventEmitter();
  @Output() submittedSuccessfully: EventEmitter<void> = new EventEmitter();

  public componentDestroyed: Subject<void> = new Subject();

  ngOnDestroy() {
    this.componentDestroyed.next();
    this.componentDestroyed.complete();
  }
}
